import { useEffect } from 'react';
import { version } from './version';
export function useAlgoliaAgent(props) {
  useEffect(function () {
    props.recommendClient.addAlgoliaAgent('recommend-react', version);
  }, [props.recommendClient]);
}